import {
  ClassificationRuleRecord,
  DeleteClassificationRuleResponse,
  GetAllClassificationRuleResponse,
  SetClassificationRuleResponse,
} from '@fullstory/proto/fs/services/search-settings';
import { createRequestReducer } from '@fullstory/redux-util';
import { combineReducers } from 'redux';
import { ClassificationRulesTypes } from './types';

const classificationRulesData = (
  state: Record<string, ClassificationRuleRecord> = {},
  action: any,
): Record<string, ClassificationRuleRecord> => {
  switch (action.type) {
    case ClassificationRulesTypes.GetAllClassificationRulesSuccess: {
      // Convert array to map keyed by ID
      const records = action.data.classificationRuleRecords || [];
      const recordsMap: Record<string, ClassificationRuleRecord> = {};

      records.forEach((record: ClassificationRuleRecord) => {
        if (record.classificationRule?.id) {
          recordsMap[record.classificationRule.id] = record;
        }
      });

      return recordsMap;
    }

    case ClassificationRulesTypes.SetClassificationRuleSuccess: {
      const updatedRecord = (action.data as SetClassificationRuleResponse).classificationRuleRecord;
      if (!updatedRecord?.classificationRule?.id) return state;

      return {
        ...state,
        [updatedRecord.classificationRule.id]: updatedRecord,
      };
    }

    case ClassificationRulesTypes.DeleteClassificationRuleSuccess: {
      const deletedRuleId = (action.data as DeleteClassificationRuleResponse).classificationRuleId;
      if (!deletedRuleId) return state;

      const newState = { ...state };
      delete newState[deletedRuleId];
      return newState;
    }

    default:
      return state;
  }
};

const classificationRules = createRequestReducer<GetAllClassificationRuleResponse>()(
  ClassificationRulesTypes.GetAllClassificationRulesRequest,
  ClassificationRulesTypes.GetAllClassificationRulesSuccess,
  ClassificationRulesTypes.GetAllClassificationRulesFailure,
);

const setClassificationRule = createRequestReducer()(
  ClassificationRulesTypes.SetClassificationRuleRequest,
  ClassificationRulesTypes.SetClassificationRuleSuccess,
  ClassificationRulesTypes.SetClassificationRuleFailure,
);

const deleteClassificationRule = createRequestReducer()(
  ClassificationRulesTypes.DeleteClassificationRuleRequest,
  ClassificationRulesTypes.DeleteClassificationRuleSuccess,
  ClassificationRulesTypes.DeleteClassificationRuleFailure,
);

type ClassificationRulesReducerState = {
  classificationRules: ReturnType<typeof classificationRules>;
  classificationRulesData: ReturnType<typeof classificationRulesData>;
  setClassificationRule: ReturnType<typeof setClassificationRule>;
  deleteClassificationRule: ReturnType<typeof deleteClassificationRule>;
};

export const classificationRulesReducer = combineReducers<ClassificationRulesReducerState>({
  classificationRules,
  classificationRulesData,
  setClassificationRule,
  deleteClassificationRule,
});
